<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>{{ stepTitle }}</h6>
      </div>
      <div class="col-md-6" *ngIf="model.siteId !== ''">
        <h6>Site Id: {{ model.siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form
    [formGroup]="formData"
    #formDirective="ngForm"
    (ngSubmit)="submit()"
    novalidate
  >
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Industry Name <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.siteName"
              matInput
              placeholder="Site Name"
              ngDefaultControl
              formControlName="siteNameCtr"
              required
            />
            <mat-error *ngIf="isFieldHasError('siteNameCtr', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="isFieldHasError('siteNameCtr', 'minlength')">
              Please legthen this text to 4 characters or more.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('siteNameCtr', 'maxlength')">
              Please provide comment up to 50 Characters.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('siteNameCtr', 'pattern')">
              Only (& . - _ / : ,) special symbol allowed.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('siteNameCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Industry type<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Choose Industry Type</mat-label>
            <mat-select
              [(ngModel)]="model.industryType"
              ngDefaultControl
              formControlName="industryTypeCtr"
              required
            >
              <mat-option>Choose Industry Type</mat-option>
              <mat-option value="Textile">Textile</mat-option>
              <mat-option value="Engineering">Engineering</mat-option>
              <mat-option value="EnterpriseIT">EnterpriseIT</mat-option>
              <mat-option value="Fabrication">Fabrication</mat-option>
              <mat-option value="Manufacturing">Manufacturing</mat-option>
              <mat-option value="Foundry">Foundry</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('industryTypeCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Site Address Line 1 <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.addressBlockNo"
              matInput
              placeholder="Building / Block Number"
              ngDefaultControl
              formControlName="addressBlockNoCtr"
              required
            />
            <mat-error *ngIf="isFieldHasError('addressBlockNoCtr', 'required')"
              >This field is required.</mat-error
            >
            <mat-error
              *ngIf="isFieldHasError('addressBlockNoCtr', 'maxlength')"
            >
              Please provide comment up to 50 Characters.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('addressBlockNoCtr', 'pattern')">
              Only (& . - _ / : ,) special symbol allowed.
            </mat-error>
            <mat-error
              *ngIf="isFieldHasError('addressBlockNoCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Lead generated By</mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Select</mat-label>
            <mat-select
              [(ngModel)]="model.leadGeneratedBy"
              ngDefaultControl
              formControlName="leadGeneratedByCtr"
              [disabled]="isReadOnly"
            >
              <mat-option>Select</mat-option>
              <mat-option value="Sales Team Member"
                >Sales Team Member</mat-option
              >
              <mat-option value="Support Team Member"
                >Support Team Member</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Site Address Line 2 <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.addressLocality"
              matInput
              placeholder="Street / Locality"
              ngDefaultControl
              formControlName="addressLocalityCtr"
              required
            />
            <mat-error *ngIf="isFieldHasError('addressLocalityCtr', 'required')"
              >This field is required.</mat-error
            >
            <mat-error
              *ngIf="isFieldHasError('addressLocalityCtr', 'maxlength')"
            >
              Please provide comment up to 50 Characters.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('addressLocalityCtr', 'pattern')">
              Only (& . - _ / : ,) special symbol allowed.
            </mat-error>
            <mat-error
              *ngIf="isFieldHasError('addressLocalityCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Execution State<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Select</mat-label>
            <mat-select
              [(ngModel)]="model.executionState"
              ngDefaultControl
              formControlName="executionStateCtr"
              required
            >
              <mat-option>Select</mat-option>

              <mat-option value="Audit Converted Flag"
                >Audit Converted Flag</mat-option
              >
              <mat-option value="Instrumentation Done"
                >Instrumentation Done</mat-option
              >
              <mat-option value="Commissioning Done"
                >Commissioning Done</mat-option
              >
              <mat-option value="Process Setup Done"
                >Process Setup Done</mat-option
              >

              <mat-option value="DashBoard Setup Done"
                >DashBoard Setup Done</mat-option
              >
              <mat-option value="GoLive">GoLive</mat-option>
              <mat-option value="NotLive">NotLive</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('executionStateCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Site City <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.city"
              matInput
              placeholder="City"
              ngDefaultControl
              formControlName="cityCtr"
              required
            />
            <mat-error *ngIf="isFieldHasError('cityCtr', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="isFieldHasError('cityCtr', 'minlength')">
              Please legthen this text to 4 characters or more.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('cityCtr', 'maxlength')">
              Please provide comment up to 50 Characters.
            </mat-error>
            <mat-error *ngIf="isFieldHasError('cityCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Energy calc method<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Select</mat-label>
            <mat-select
              [(ngModel)]="model.energyCalcMethod"
              ngDefaultControl
              formControlName="energyCalcMethodCtr"
              required
            >
              <mat-option>Select</mat-option>
              <mat-option value="Real Time Power by 60"
                >Real Time Power by 60</mat-option
              >
              <mat-option value="Delta Energy">Delta Energy</mat-option>
              <mat-option value="Summation of RealtimeEnergy"
                >Summation of RealtimeEnergy</mat-option
              >
              <mat-option value="DCU Shiftly Energy" disabled
                >DCU Shiftly Energy</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="isFieldHasError('energyCalcMethodCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Site PinCode <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.pinCode"
              matInput
              placeholder="PinCode"
              ngDefaultControl
              formControlName="pinCodeCtr"
              required
            />
            <mat-error *ngIf="isFieldHasError('pinCodeCtr', 'required')"
              >This field is required.</mat-error
            >
            <mat-error *ngIf="isFieldHasError('pinCodeCtr', 'maxlength')"
              >This field takes upto 10 digits.</mat-error
            >
            <mat-error *ngIf="isFieldHasError('pinCodeCtr', 'pattern')"
              >only digits allowed.</mat-error
            >
            <mat-error *ngIf="isFieldHasError('pinCodeCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Timezone<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Select Timezone</mat-label>
            <mat-select
              [(ngModel)]="model.timezone"
              ngDefaultControl
              formControlName="timezoneCtr"
              required
            >
              <mat-option>Select Timezone</mat-option>
              <mat-option *ngFor="let item of timezones" [value]="item.id">{{
                item.text
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('timezoneCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Industry Segment <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Choose Segment</mat-label>
            <mat-select
              [(ngModel)]="model.industrySegment"
              ngDefaultControl
              formControlName="industrySegmentCtr"
              [disabled]="isReadOnly"
            >
              <mat-option>Choose Segment</mat-option>
              <mat-option value="Large">Large</mat-option>
              <mat-option value="Medium">Medium</mat-option>
              <mat-option value="Small">Small</mat-option>
              <mat-option value="Micro">Micro</mat-option>
              <mat-option value="Commercial">Commercial</mat-option>
              <mat-option value="Residential">Residential</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('industrySegmentCtr', 'required')"
              >Please select an item in the list.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Feature Opted<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Choose Feature</mat-label>
            <mat-select
              [(ngModel)]="model.featureOpted"
              ngDefaultControl
              formControlName="featureOptedCtr"
              [disabled]="isReadOnly"
            >
              <mat-option>Choose Feature</mat-option>
              <mat-option value="EMS">EMS</mat-option>
              <mat-option value="EMS+">EMS+</mat-option>
              <mat-option value="DR">DR</mat-option>
              <mat-option value="Aggregated Trading"
                >Aggregated Trading</mat-option
              >
              <mat-option value="Backup Power">Backup Power</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Go Live Date<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker1"
              ngDefaultControl
              [formControl]="goLiveDate"
              [disabled]="isReadOnly"
              [max]="max"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
              [disabled]="isReadOnly"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #picker1
              [disabled]="isReadOnly"
              required
            ></mat-datepicker>
            <mat-error *ngIf="goLiveDate.invalid">Invalid Date</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >KPI Utilities<span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Choose Utilities</mat-label>
            <mat-select
              id="utility"
              multiple
              [(ngModel)]="model.configuredKpiUtilities"
              ngDefaultControl
              formControlName="utilityOptedCtr"
              [disabled]="isReadOnly"
            >
              <mat-option
                *ngFor="let utility of availableKPIUtilities"
                [value]="utility"
                >{{ utility }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="isFieldHasError('utilityOptedCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Next follow-up Date</mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker2"
              ngDefaultControl
              [formControl]="nextFollowUpDate"
              [disabled]="isReadOnly"
              [min]="max"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
              [attr.disabled]="isReadOnly"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #picker2
              [attr.disabled]="isReadOnly"
            ></mat-datepicker>
            <mat-error *ngIf="nextFollowUpDate.invalid">Invalid Date</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right">Logo</mat-label>
        </div>
        <div class="col-md-8">
          <input
            type="file"
            id="uploadLogo"
            (change)="uploadDocument($event, 'Logo')"
            class="hidden"
            accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
          />
          <button
            type="button"
            id="uploadLogoId"
            [disabled]="isReadOnly"
            matTooltip="Select logo picture"
            (click)="selectDocument('uploadLogo')"
            bciprimarybutton
          >
            <mat-icon
              aria-hidden="false"
              aria-label="icon"
              class="bosch-ic-paperclip mat-icon Bosch-Ic"
              style="width: max-content"
            ></mat-icon>
          </button>
          <input
            type="text"
            formControlName="uploadLogoCtr"
            [(ngModel)]="logoAttachment.name"
            readonly
          />
          <mat-error
            class="upload-image-error"
            *ngIf="isFieldHasError('uploadLogoCtr', 'required')"
          >
            This field is required.
          </mat-error>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"></mat-label>
        </div>
        <div class="col-md-8">
          <mat-checkbox
            [(ngModel)]="model.layoutNavigateFeature"
            ngDefaultControl
            formControlName="layoutNavigateFeatureCtr"
            [disabled]="isReadOnly"
            >Enable Layout Navigate Feature?</mat-checkbox
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right">Layout</mat-label>
        </div>
        <div class="col-md-8">
          <input
            type="file"
            id="uploadLayout"
            (change)="uploadDocument($event, 'Layout')"
            class="hidden"
            accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
          />
          <button
            type="button"
            id="uploadLayoutId"
            [disabled]="isReadOnly"
            matTooltip="Select layout picture"
            (click)="selectDocument('uploadLayout')"
            bciprimarybutton
          >
            <mat-icon
              aria-hidden="false"
              aria-label="icon"
              class="bosch-ic-paperclip mat-icon Bosch-Ic"
              style="width: max-content"
            ></mat-icon>
          </button>
          <input
            type="text"
            formControlName="uploadLayoutCtr"
            [(ngModel)]="layoutAttachment.name"
            readonly
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-2">
          <mat-label class="label-input pull-right">Other documents</mat-label>
        </div>
        <div class="col-md-10">
          <div
            class="row"
            *ngFor="let item of otherAttachments; let $index = index"
          >
            <div class="col-md-4">
              <input
                type="file"
                (change)="uploadDocument($event, 'Other', $index)"
                accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png,application/pdf"
              />
              {{ item.name }} <br />
            </div>
            <div class="col-md-4">
              <mat-form-field class="text-area">
                <textarea
                  matInput
                  ngDefaultControl
                  [(ngModel)]="item.comment"
                  [(disabled)]="isReadOnly"
                  matInput
                  placeholder="Comment"
                  maxlength="200"
                  [ngModelOptions]="{ standalone: true }"
                >
                </textarea>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <button
                id="removeDocumnets"
                bciprimarybutton
                class="button-primary"
                [(disabled)]="isReadOnly"
                matTooltip="Remove document"
                (click)="removeDocument($index)"
              >
                <mat-icon
                  aria-hidden="false"
                  aria-label="icon"
                  class="bosch-ic-subtract-frame mat-icon Bosch-Ic"
                  style="width: max-content"
                ></mat-icon>
              </button>
              &nbsp;

              <button
                id="addDocuments"
                *ngIf="$index === otherAttachments.length - 1"
                [(disabled)]="isReadOnly"
                matTooltip="Add more document"
                (click)="addMoreDocument()"
                bciprimarybutton
                class="button-primary"
              >
                <mat-icon
                  aria-hidden="false"
                  aria-label="icon"
                  class="bosch-ic-add mat-icon Bosch-Ic"
                  style="width: max-content"
                ></mat-icon>
              </button>
            </div>
          </div>
          <button
            id="addOtherDocuments"
            *ngIf="otherAttachments.length === 0"
            [(disabled)]="isReadOnly"
            matTooltip="Add more document"
            (click)="addMoreDocument()"
            bciprimarybutton
            class="button-primary"
          >
            <mat-icon
              aria-hidden="false"
              aria-label="icon"
              class="bosch-ic-add mat-icon Bosch-Ic"
              style="width: max-content"
            ></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="text-align: center">
        <button
          id="submitbtn"
          bciprimarybutton
          class="button-primary"
          type="submit"
          *ngIf="visibleSubmitButton() || !isReadOnly"
          [disabled]="!formData.valid"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
          Submit
        </button>
        &nbsp;
        <button
          id="editbtn"
          bciprimarybutton
          class="button-primary"
          *ngIf="visibleEditButton()"
          (click)="invertEdit($event)"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-edit"
              style="width: max-content"
            ></mat-icon>
          </span>
          Edit
        </button>
        &nbsp;
        <button
          id="resetbtn"
          bciprimarybutton
          class="button-primary"
          *ngIf="visibleResetButton()"
          (click)="reset($event)"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-reset"
              style="width: max-content"
            ></mat-icon>
          </span>
          Reset
        </button>
        &nbsp;
        <button
          id="nextbtn"
          bciprimarybutton
          class="button-primary"
          [disabled]="!formData.valid || !enableNextStep"
          (click)="goTo($event)"
        >
          Next
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-right-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
        </button>
      </div>
    </div>
  </form>
</mat-expansion-panel>
